module.exports = __webpack_public_path__ + "img/DefaultFeedbackOkay.8d1d26b7.png";